import apiVersion from '../_helpers/api-version';
import queryString from 'query-string';
import axiosInstance from '../_helpers/axiosConfig'

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'

export const service = {
  clientRead,
  messageRead,
  sendOrCreateLink,
  sendOrCreateMessage,
  sendOrCreateAttachment,
  sendLink,
  sendMessage,
  sendAttachment,
  addParticipant,
  getConversation,
  getParticipants,
  getConversations,
  retrieveMessages,
  closeConversation,
  reopenConversation,
  followConversation,
  getParticipantAttention,
  setShouldReceiveNotification
}

function clientRead(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/client-read`,
  });
}

function messageRead(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/read`,
  }).then((response) => {
    return response.data;
  })
}

function reopenConversation(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/reopen`,
    headers: authHeader(),
    method: 'POST'
  }).then((response) => {
    return response.data;
  });
}

function closeConversation(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/close`,
    headers: authHeader(),
    method: 'POST'
  }).then((response) => {
    return response.data;
  });
}

function followConversation(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/follow`,
    headers: authHeader(),
    method: 'POST'
  }).then((response) => {
    return response.data;
  });
}

function getConversations(params) {
  const clientId = store.getState().client.id;

  const baseURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}`;
  const serviceURL = `${baseURL}/conversation?${queryString.stringify(params)}`;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function getConversation(conversationId) {
  const clientId = store.getState().client.id;

  const serviceURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}`;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function getParticipants(params = {}) {
  const clientId = store.getState().client.id;

  const baseURL = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}`
  const serviceURL = `${baseURL}/user?${queryString.stringify(params)}`;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: serviceURL,
  }).then((response) => {
    return response.data;
  })
}

function addParticipant(conversationId, userId, notifications) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/participant`,
    headers: authHeader(),
    method: 'POST',
    data: { userId, notifications },
  }).then((response) => {
    return response.data;
  })
}

function getParticipantAttention(conversationId, paricipantId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/participant/${paricipantId}/attention`,
    headers: authHeader(),
    method: 'POST',
  }).then((response) => {
    return response.data;
  })
}

function sendOrCreateMessage(message, conversationId = null, patientId = null, socketId = null) {
  const clientId = store.getState().client.id;

  let baseUrl = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation`

  if (conversationId) {
    baseUrl = `${baseUrl}/${conversationId}/message`
  }

  return axiosInstance.request({
    url: baseUrl,
    headers: authHeader(),
    method: 'POST',
    data: {
      type: 'message',
      message,
      socketId,
      patientId
    }
  }).then((response) => {
    return response.data;
  })
}

function sendMessage(conversationId, message, socketId = null) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/message`,
    headers: authHeader(),
    method: 'POST',
    data: {
      type: 'message',
      message: message,
      socketId
    }
  }).then((response) => {
    return response.data;
  })
}

function sendOrCreateLink(link, conversationId = null, patientId = null, socketId = null) {
  const clientId = store.getState().client.id;

  let baseUrl = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation`

  if (conversationId) {
    baseUrl = `${baseUrl}/${conversationId}/message`
  }

  return axiosInstance.request({
    url: baseUrl,
    headers: authHeader(),
    method: 'POST',
    data: {
      type: 'link',
      link,
      socketId,
      patientId
    }
  }).then((response) => {
    return response.data;
  })
}

function sendLink(conversationId, link, socketId = null) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/message`,
    headers: authHeader(),
    method: 'POST',
    data: {
      type: 'link',
      link: link,
      socketId
    }
  }).then((response) => {
    return response.data;
  })
}

function sendOrCreateAttachment(file, conversationId = null, patientId = null, socketId = null) {
  const clientId = store.getState().client.id;

  let baseUrl = `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation`

  if (conversationId) {
    baseUrl = `${baseUrl}/${conversationId}/message`
  }

  const formData = new FormData();
  formData.append('attachment', file, file.name);
  formData.append('type', 'attachment');
  formData.append('socketId', socketId)
  formData.append('patientId', patientId)

  return axiosInstance.request({
    url: baseUrl,
    headers: authHeader(),
    method: 'POST',
    data: formData
  }).then((response) => {
    return response.data;
  })
}

function sendAttachment(conversationId, file, socketId) {
  const clientId = store.getState().client.id;

  const formData = new FormData();
  formData.append('attachment', file, file.name);
  formData.append('type', 'attachment');
  formData.append('socketId', socketId)

  return axiosInstance.request({
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/message`,
    headers: authHeader(),
    method: 'POST',
    data: formData
  }).then((response) => {
    return response.data;
  })
}

function retrieveMessages(conversationId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/message`,
  }).then((response) => {
    return response.data;
  })
}

function setShouldReceiveNotification(conversationId, shouldNotify) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/conversation/${conversationId}/notification-settings`,
    data: {
      notificationSetting: shouldNotify,
    }
  }).then((response) => {
    return response.data;
  })
}